export const STRIPE_KEY='pk_live_51KgST9Jz0Xxp8umGLUz9lWTQDmShOY4sF9XC57aj7473huXokAKlYRAm5of1k0ccnX5hboYeWlzuFYDElk12QSKN0045v8wsfg'


